import React from "react";
import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { InsertDocumentPopup } from "../Documents/InsertDocumentPopup.js";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
function ClearanceAgentStarredOrdersListing() {
  return (
    <GenericOrdersListing
      title="Starred Orders"
      isReleased={false}
      isCanceled={false}
      readOnly={false}
      icon={AssignmentRoundedIcon}
      InsertDocumentPopup={InsertDocumentPopup}
      ChatPopup={ChatPopup}
      showAddOrder={false}
      showAddDocument={true}
      showAddApproval={true}
      showAddInvoice={true}
      showAddCargoX={true}
      isStarred={true}
    />
  );
}

export default ClearanceAgentStarredOrdersListing;
